import React from 'react';
import { apiGetContactList, apiIsLoggedIn } from '../api/api';
import ContactListTable from '../components/tables/ContactListTable';
import '../styles/contactlist.css';
import TopBarMain from '../components/topbars/TopBarMain';

class ContactListPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            contactList: [],
            headers: [],
        };
    }

    render() {
        return (
            <div>
                <TopBarMain />
                <div className="contact-list-page">
                    <h2>Contact List</h2>
                    <ContactListTable />
                </div>
            </div>
        );
    }
}

export default ContactListPage;
